module.exports = __webpack_public_path__ + "img/arbitrium.94f38c5e.png";